<template>
  <div></div>
</template>

<script>
export default {
  name: 'RefreshPage',
  beforeCreate () {
    const params = this.$route.params
    const query = this.$route.query
    if (params.redirect) this.$router.push(params.redirect)
    else this.$router.push({ name: this.$route.params.name, params: { id: this.$route.params.id }, query: query || {} })
  }
}
</script>

<style scoped>

</style>
